"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LTARColsUpdater", {
    enumerable: true,
    get: function() {
        return LTARColsUpdater;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _profiler = require("~/helpers/profiler");
const _models = require("~/models");
const _addremovelinks = require("~/db/BaseModelSqlv2/add-remove-links");
const LTARColsUpdater = (param)=>{
    const { baseModel } = param;
    const update = async ({ datas, cookie })=>{
        const profiler = _profiler.Profiler.start(`base-model/updateLTARCols`);
        const trx = await baseModel.dbDriver.transaction();
        // Create a BaseModelSqlv2 instance that uses the transaction for operations
        // while preserving the original dbDriver reference for non-transactional operations
        const trxBaseModel = await _models.Model.getBaseModelSQL(baseModel.context, {
            model: baseModel.model,
            transaction: trx,
            dbDriver: baseModel.dbDriver
        });
        try {
            for (const col of baseModel.model.columns){
                // skip if not LTAR or Links
                if (!(0, _nocodbsdk.isLinksOrLTAR)(col)) continue;
                for (const d of datas){
                    const rowId = baseModel.extractPksValues(d, true);
                    // skip if value is not part of the update
                    if (!(col.title in d)) continue;
                    // extract existing link values to current record
                    let existingLinks = [];
                    profiler.log(`${col.colOptions.type} list start`);
                    if ((0, _nocodbsdk.isMMOrMMLike)(col)) {
                        existingLinks = await trxBaseModel.mmList({
                            colId: col.id,
                            parentId: rowId
                        });
                    } else if (col.colOptions.type === _nocodbsdk.RelationTypes.HAS_MANY) {
                        existingLinks = await trxBaseModel.hmList({
                            colId: col.id,
                            id: rowId
                        });
                    } else {
                        existingLinks = await trxBaseModel.btRead({
                            colId: col.id,
                            id: rowId
                        });
                    }
                    profiler.log(`${col.colOptions.type} list done`);
                    existingLinks = existingLinks || [];
                    if (!Array.isArray(existingLinks)) {
                        existingLinks = [
                            existingLinks
                        ];
                    }
                    const idsToLink = [
                        ...(Array.isArray(d[col.title]) ? d[col.title] : [
                            d[col.title]
                        ]).map((rec)=>baseModel.extractPksValues(rec, true))
                    ];
                    // check for any missing links then unlink
                    const idsToUnlink = existingLinks.map((link)=>baseModel.extractPksValues(link, true)).filter((existingLinkPk)=>{
                        const index = idsToLink.findIndex((linkPk)=>{
                            return existingLinkPk === linkPk;
                        });
                        // if found remove from both list
                        if (index > -1) {
                            idsToLink.splice(index, 1);
                            return false;
                        }
                        return true;
                    });
                    // check for missing links in new data and unlink them
                    if (idsToUnlink == null ? void 0 : idsToUnlink.length) {
                        profiler.log(`${col.colOptions.type} removeLinks start`);
                        await trxBaseModel.removeLinks({
                            colId: col.id,
                            childIds: idsToUnlink,
                            cookie,
                            rowId
                        });
                        profiler.log(`${col.colOptions.type} removeLinks done`);
                    }
                    // check for new data and link them
                    if (idsToLink == null ? void 0 : idsToLink.length) {
                        profiler.log(`${col.colOptions.type} addLinks start`);
                        await trxBaseModel.addLinks({
                            colId: col.id,
                            childIds: idsToLink,
                            cookie,
                            rowId
                        });
                        profiler.log(`${col.colOptions.type} addLinks done`);
                    }
                }
            }
            await trx.commit();
        } catch (e) {
            await trx.rollback();
            throw e;
        }
        profiler.end();
    };
    const updateForColumn = async ({ linkDataPayload, col, cookie })=>{
        const promises = [];
        for (const each of linkDataPayload.data){
            promises.push((0, _addremovelinks.addOrRemoveLinks)(baseModel).addLinks({
                cookie,
                childIds: each.links,
                colId: col.id,
                rowId: each.rowId
            }));
        }
        return Promise.all(promises);
    };
    return {
        updateLTARCols: update,
        updateLTARCol: updateForColumn
    };
};
